import React, { Component } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'

import InputRows from './InputRows'
import MenuList from '../Menu'
import Service from './Service'
import Helpers from '../../../libs/helpers'
import {menu, language, swalText} from '../../../Constants'
import './home.scss'
import 'sweetalert2/src/sweetalert2.scss'

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: []
        }
    }

    componentDidMount() {
        axios.post('/api/check').then(result => {
            if (result.data.message !== 'you Were authorized') {
                this.props.history.push('/admin');
                return;
            }
            axios.post('/api/services/getAll').then(result => {
                let services = result.data.result;
                this.setState({
                    services,
                    initialized: true,
                });
                document.title = menu[0].text;
            })
        }).catch(res => {
            if (res) this.props.history.push('/admin');
        });

    }

    render() {
        if (!this.state.initialized) return null;
        let inputRow = language.map(lang => <InputRows lang={ lang }/>);
        return (
            <div id='homePage'>
                <MenuList history={ this.props.history }/>
                <div id='right'>
                    <header><h1>{menu[0].text}</h1></header>
                    <div>
                        <h3><em>Ավելացնել ծառայություն</em></h3>
                        <form onSubmit={this.addService}>
                            <div id='formRight'>{ inputRow }</div>
                            <div id='priceTag'>
                                <label htmlFor="price">Գինը</label>
                                <input type="number" id='price' min='0' step='1' placeholder={'Price'}/>
                            </div>
                            <button>Ավելացնել</button>
                        </form>
                    </div>
                    <div id='showAll'>
                        <h3><em>{menu[0].text}</em></h3>
                        <div id='services'>
                            {this.state.services.map(service =>
                                <Service key={service.id} service={service} change={this.change}/>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    addService = e => {
        e.preventDefault();
        let enName = document.getElementById('enName').value.trim();
        let ruName = document.getElementById('ruName').value.trim();
        let armName = document.getElementById('armName').value.trim();
        let enDesc = document.getElementById('enDescription').value.trim();
        let ruDesc = document.getElementById('ruDescription').value.trim();
        let armDesc = document.getElementById('armDescription').value.trim();

        let price = document.getElementById('price').value.trim();

        let info = [enName, enDesc, ruName, ruDesc, armName, armDesc];
        let errors = Helpers.checkErrors(info);
        if (errors.length) {
            Swal.fire({
                type: 'error',
                title: 'Կիսատ ինֆորմացիա',
                text: 'Լրացրեք բոլոր դաշտերը'
            });
            let tags = document.querySelectorAll('.row > input, .row > textarea');
            tags.forEach((el, index) => {
                errors.includes(index) ? el.classList.add('error') : el.classList.remove('error');
            });
            return;
        }
        axios.put('/api/services/add', {info, price}).then(result => {
            let services = this.state.services;
            let id = result.data.id;
            services.push({
                id,
                price,
                data: [
                    {
                        language: 'en',
                        name: enName,
                        description: enDesc
                    },
                    {
                        language: 'ru',
                        name: ruName,
                        description: ruDesc
                    },
                    {
                        language: 'arm',
                        name: armName,
                        description: armDesc
                    }
                ]
            });
            this.setState({
                services : services
            },() => {
                Swal.fire({
                    type: 'success',
                    title: swalText.titleSuccess,
                    confirmButtonText: swalText.ok
                })
            })
        });
    };

    change = (newService) => {
        let services = this.state.services;
        services.forEach((el, index) => {
            if(el.id === newService.id) services[index] = newService;
        });
        this.setState({ services })
    }
}
